import Loader from '@/components/Atoms/Loader/Loader'

import cn from './SubscriptionCreationModal.module.scss'

type SelectNotFoundProps = {
  loading: boolean
}

function SelectNotFound({ loading }: SelectNotFoundProps) {
  return loading ? (
    <div className={cn.selectLoader}>
      <Loader size={14} />
    </div>
  ) : (
    <span className={cn.selectEmpty}>Ничего не найдено</span>
  )
}

export default SelectNotFound
